module.exports = __webpack_public_path__ + "assets/img/empty-CN.629eb0b2.png";